<div class="emoji-search-container">
  <input type="text" [(ngModel)]="searchTerm" (input)="filterEmojis()" placeholder="Search emojis..." />
</div>
<div class="emoji-list-container">
  <div *ngFor="let emoji of filteredEmojis" class="emoji-item" (click)="selectEmoji(emoji)">
    {{ emoji }}
  </div>
</div>
